export const customPropEquality = (prevProps, nextProps, excludedProps) => {
  let isEqual = true;
  prevProps &&
    nextProps &&
    Object.keys(prevProps).forEach((propKey) => {
      if (
        !excludedProps.find((excludedProp) => excludedProp.name === propKey)
      ) {
        const normalComparison = Object.is(
          prevProps[propKey],
          nextProps[propKey]
        );
        isEqual = isEqual && normalComparison;
      }
    });
  excludedProps.forEach((excludedProp) => {
    isEqual = isEqual && excludedProp.isEqual;
  });
  return isEqual;
};
